import { Text } from "sunrise-ui";

const TextComponent = (props: any) => {
  return (
    <Text
      type="normal"
      fonts="normal"
      fontSize={props.fontSize ? props.fontSize : 16}
      className={`mb0 mt0 ${props.class}`}
    >
      <span className="fw500">
        {props.title}
        {props.isMandatory && <sup>*</sup>}{" "}
      </span>
    </Text>
  );
};

export default TextComponent;
